// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__n3twf","desabilitar":"OptionSelect_desabilitar__nwsPe","focado":"OptionSelect_focado__y8VPJ","novo":"OptionSelect_novo__DK7EB"};